var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import theme from '../../../theme';
import FAQDetails from './FAQDetails';
import { AnimatedIcon, FAQRowWrapper, IconContainer, QuestionText, RowButton } from './subcomponents';
var FAQRow = function (_a) {
    var questionHeader = _a.questionHeader, answerBody = _a.answerBody;
    var _b = useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var dataReason = "question-".concat(!isExpanded ? 'expanded' : 'collapsed', ":").concat(questionHeader.slice(0, 20));
    var handleClick = function () { return setIsExpanded(function (prevExpanded) { return !prevExpanded; }); };
    return (_jsxs(FAQRowWrapper, { children: [_jsxs(RowButton, __assign({ type: "button", onClick: handleClick, "aria-expanded": isExpanded, "data-type": "dispute-transaction", "data-title": "dispute-transaction", "data-reason": dataReason, "data-analytics": "clicktrackingevent", "data-object": "button" }, { children: [_jsx(QuestionText, __assign({ weight: "semiBold" }, { children: questionHeader })), _jsx(IconContainer, { children: _jsx(AnimatedIcon, { name: "faChevronDown", color: theme.colors.denimBlue, size: "lg", "$isExpanded": isExpanded }) })] })), _jsx(FAQDetails, { "aria-hidden": !isExpanded, details: answerBody, isExpanded: isExpanded })] }));
};
export default FAQRow;
//# sourceMappingURL=FAQRow.js.map